// $(function() {
//   $meta = $(".sp-pcp-post:not(.type-persons) .sp-pcp-post-meta ul");

//   $meta.each(function() {
//     $address = $(this).find("li").eq(1).text();
//     $(this).find("li").eq(1).text("");
//     $(this).find("li").eq(1).append("<a href='mailto:" + $address + "'>" + $address + "</a>");
//   });
// });
